import React from "react";

import "./Spinner.scss";

export type SpinnerProps = {
  bgColor: "black" | "white" | "primary";
};

export const Spinner: React.FC<SpinnerProps> = ({ bgColor = "primary" }) => {
  return <div className={`Spinner ${bgColor}`} />;
};
